// extracted by mini-css-extract-plugin
export default {"PortfolioCallToAction":"qYi24uBym7aZ9bV1Dw1c","Description":"OLLGiGuxLc9wTqkMQPbL","Link":"MRlQkiu1Mdteq_EefGH9","Variant--rounded":"ZiV_pbi2dmr8WWmMB29l"};